<template>
  <b-row v-show="!_isPending || (_isPending && tyProduct.pivot.status === 0)">
    <b-col
      md="5"
    >
      <b-row>
        <b-col
          md="4"
        >
          <div v-if="product.images">
            <div
              v-if="product.images[0]"
              class="clearfix"
              @click="showImages"
            >
              <b-img
                :src="'https://api.kitapfirsatlari.com/' + product.images[0].url"
                width="150"
              />
            </div>
          </div>
        </b-col>
        <b-col
          md="8"
        >
          <a
            href="#"
            target="_blank"
          >
            <feather-icon icon="ExternalLinkIcon" />
          </a> {{ product.id }}

          <b-badge
            variant="info"
            @click="tyMatching"
          >
            Ty SKU Ekle
          </b-badge>

          <a
            :href="`/trendyol/urun-ara?product_id=${product.id}&barcode=${product.barcode}&name=${product.name}`"
            target="_blank"
            class="badge badge-primary"
          >
            <feather-icon icon="SearchIcon" v-b-popover.hover.top="'Trendyolda Ara'"/>
          </a>
          <br>

          <br>
          <b-badge :variant="tyProduct.merchant_sku==product.barcode?'success':''">
            {{ product.barcode }}
          </b-badge>
          <br>
          <b-badge v-if="product.brand">
            {{ product.brand.name }}
          </b-badge>
          <b-badge v-else-if="product.publishers[0]">
            {{ product.publishers[0].publisher_name }}
          </b-badge>
          <b-badge v-else>
            -
          </b-badge>
          <br>

          <b-badge v-if="product.categories[0]">
            {{ product.categories[0].name }}
          </b-badge>
          <b-badge v-else>
            -
          </b-badge>
          <br>

          <div
            style="word-wrap:break-word;"
            :class="tyProduct.product_name==product.name?'bg-success text-white':'bg-secondary text-white'"
          >
            {{ product.name }}
          </div>

          <b-button-group size="sm">
            <a
              v-for="supplierProduct in product.supplier_products"
              :key="supplierProduct.id"
              class="bg-info text-white mr-1"
              target="_blank"
              :href="supplierProduct.url"
            >
              <b>
                {{ supplier_name(supplierProduct.supplier_id) }} {{ supplierProduct.stock }} Ad. {{
                  supplierProduct.price
                }}
                {{ supplierProduct.currency }}
              </b>
            </a>
          </b-button-group>
        </b-col>
      </b-row>
    </b-col>

    <b-col
      md="5"
    >
      <b-row>
        <b-col
          md="4"
        >
          <div v-if="tyProduct.images">
            <div
              v-if="tyProduct.images[0]"
              class="clearfix"
              @click="showImages"
            >
              <b-img
                :src="tyProduct.images[0].url"
                width="150"
              />
            </div>
          </div>
        </b-col>

        <b-col md="8">
          <b-row>
            <b-col md="12">
              <a
                :href="'https://www.trendyol.com/w/w-w-p-'+tyProduct.productContentId"
                target="_blank"
              >
                <feather-icon icon="ExternalLinkIcon" />
              </a> {{ tyProduct.id }}
              <b-badge
                variant="info"
                @click="productMatching"
              >
                Ürün No Ekle
              </b-badge>
              <br>

              <br>
              <b-badge :variant="tyProduct.merchant_sku==product.barcode?'success':''"> {{
                tyProduct.merchant_sku
              }}
              </b-badge>
              <br>
              <b-badge v-if="tyProduct.detail">
                {{ JSON.parse(tyProduct.detail.detail).brandName }}
              </b-badge>
              <b-badge v-else>
                -
              </b-badge>
              <br>

              <b-badge v-if="tyProduct.detail">
                {{ JSON.parse(tyProduct.detail.detail).categoryName }}
              </b-badge>
              <b-badge v-else>
                -
              </b-badge>
              <br>

              <div
                style="word-wrap:break-word;"
                :class="tyProduct.product_name==product.name?'bg-success text-white':'bg-secondary text-white'"
              >
                {{ tyProduct.product_name }}
              </div>

              <b-button-group>
                <div v-if="tyProduct.buybox_list">
                  <a
                    v-for="(list,lIndex) in JSON.parse(tyProduct.buybox_list.list)"
                    :key="lIndex"
                    class="bg-info text-white mr-1"
                  >
                    <b>{{ list.merchantName }} {{ list.discountedPrice }} {{ list.currency }}</b>
                  </a>
                </div>
              </b-button-group>

            </b-col>

          </b-row>
        </b-col>

      </b-row>
    </b-col>

    <b-col
      md="2"
    >
      <div>
        <b-form-checkbox
          v-model="tyProduct.matching"
          class="custom-control-success"
          name="check-button"
          switch
        />
      </div>
      <div>
        <b-badge
          class="mt-1"
          :variant="matching_status_color(tyProduct.pivot.status)"
        >{{
          matching_status(tyProduct.pivot.status)
        }}
        </b-badge>
      </div>
      <div>
        <b-button-group class="mt-1">
          <b-button
            size="sm"
            variant="success"
            @click="toSendStatus(2)"
          >
            Onayla
          </b-button>
          <b-button
            size="sm"
            variant="warning"
            @click="toSendStatus(5)"
          >
            Ertele
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            @click="toSendStatus(4)"
          >
            Reddet
          </b-button>
        </b-button-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import supplierMixins from '@/mixins/supplierMixins'
import matchingStatusMixins from '@/mixins/matchingStatusMixins'
import MatchingStoreProduct from '@/views/trendyol/matching/MatchingStoreProduct'

export default {
  name: 'ProductMatchProduct',
  mixins: [supplierMixins, matchingStatusMixins, MatchingStoreProduct],
  props: {
    tyIndex: {
      type: Number,
      required: true,
    },
    tyProduct: {
      type: Object,
      required: true,
    },
    pIndex: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('tyProductMatch', ['_isPending']),
    ...mapGetters('tyProduct', ['_matchingIds']),
  },
  methods: {
    showImages() {

    },
    toSendStatus(statusId) {
      this.product.matching = false
      const ids = [{
        ty_product_id: this.tyProduct.id,
        product_id: this.product.id,
        status: statusId,
      }]
      this.$store.dispatch('tyProductMatch/setProductsPivotStatusData', ids)
    },
    productMatching() {
      this.$swal({
        title: 'Ürün No Girin',
        input: 'text',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Ekle',
        showLoaderOnConfirm: true,
        preConfirm: productId => {
          if (!productId) return null
          return this.$store.dispatch('product/addTyMatchingProduct', { productId, sku: this.tyProduct.merchant_sku })
            .then(res => res)
        },
      })
        .then(result => {
          if (result.value) {
            this.$swal({
              title: result.value.message,
              icon: result.value.status,
            })
          }
        })
    },
    tyMatching() {
      this.$swal({
        title: 'Pazaryeri SKU Girin',
        input: 'text',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Ekle',
        showLoaderOnConfirm: true,
        preConfirm: sku => {
          if (!sku) return null
          return this.$store.dispatch('product/addTyMatchingProduct', { productId: this.product.id, sku })
            .then(res => res)
        },
      })
        .then(result => {
          if (result.value) {
            this.$swal({
              title: result.value.message,
              icon: result.value.status,
            })
          }
        })
    },
  },
}
</script>

<style scoped>

</style>
